export const mapAppOpation = [
  { value: "Grease Trap Cleaning", label: "Grease Trap Cleaning" },
];

export const restaurantType = [
  {
    id: 1,
    value: "RG1",
    label: "Restaurant Group 1",
  },
  {
    id: 2,
    value: "RG2",
    label: "Restaurant Group 2",
  },
  {
    id: 3,
    value: "RG3",
    label: "Restaurant Group 3",
  },
];
export const restaurantCity = [
  {
    value: "manila",
    label: "Manila",
  },
  {
    value: "Caloocan",
    label: "Caloocan",
  },
  {
    value: "Las Piñas",
    label: "Las Piñas",
  },
  {
    value: "Makati",
    label: "Makati",
  },
  {
    value: "Malabon",
    label: "Malabon",
  },
  {
    value: "Mandaluyong",
    label: "Mandaluyong",
  },
  {
    value: "Marikina",
    label: "Marikina",
  },
];

// Static data for restaurants across the Philippines
export const restaurantGroups = [
  {
    label: "Group of Restaurant - 1",
    value: "Group of Restaurant - 1",
    branches: [
      { label: "All Branches", value: "all" },
      {
        label: "Wendy’s Dapitan",
        value: "Wendy’s Dapitan",
        address:
          "Wendy's - Dapitan, 1427 Dapitan St, Sampaloc, Manila, 1015 Metro Manila",
        city: "Manila",
        lat: 14.6118755,
        lng: 120.9883965,
        isClean: false,
      },
      {
        label: "Wendy’s UN",
        value: "Wendy’s UN",
        address:
          "Wendy's - UN Avenue, United Nations Avenue, Ermita, Manila, Metro Manila",
        city: "Manila",
        lat: 14.6042,
        lng: 120.9822,
        isClean: true,
      },
      {
        label: "Wendy’s Robinsons Ermita",
        value: "Wendy’s Robinsons Ermita",
        address:
          "Wendy's - Robinsons Ermita, Pedro Gil Street, Ermita, Manila, Metro Manila",
        city: "Manila",
        lat: 14.576686,
        lng: 120.983879,
        isClean: false,
      },
    ],
  },
  {
    label: "Group of Restaurant - 2",
    value: "Group of Restaurant - 2",
    branches: [
      { label: "All Branches", value: "all" },
      {
        label: "Conti's Bakery & Café - Robinsons Place Manila",
        value: "Conti's Bakery & Café - Robinsons Place Manila",
        address:
          "Conti's Bakery & Café - Robinsons Place Manila, Pedro Gil Street, Ermita, Manila, Metro Manila",
        city: "Manila",
        lat: 14.576686,
        lng: 120.983879,
        isClean: true,
      },
      {
        label: "Conti's UN Avenue",
        value: "Conti's UN Avenue",
        address:
          "Conti's UN Avenue, Maria Orosa Street, Ermita, Manila, Metro Manila",
        city: "Manila",
        lat: 14.5785921,
        lng: 120.9794956,
        isClean: true,
      },
      {
        label: "Conti's Take Out Nook - SM San Lazaro",
        value: "Conti's Take Out Nook - SM San Lazaro",
        address:
          "Conti's Take Out Nook - SM San Lazaro, cor, Lacson Avenue, Santa Cruz, Manila, Metro Manila",
        city: "Manila",
        lat: 14.6182232,
        lng: 120.9858834,
        isClean: false,
      },
    ],
  },
  {
    label: "Group of Restaurant - 3",
    value: "Group of Restaurant - 3",
    branches: [
      { label: "All Branches", value: "all" },
      {
        label: "Wendy's - Makati Avenue",
        value: "Wendy's - Makati Avenue",
        address:
          "Wendy's - Makati Avenue, General Luna, Makati City, Metro Manila",
        city: "Manila",
        lat: 14.5651836,
        lng: 121.0298214,
        isClean: true,
      },
      {
        label: "Wendy's - SM Jazz Mall",
        value: "Wendy's - SM Jazz Mall",
        address:
          "Wendy's - SM Jazz Mall, Nicanor Garcia Street, Makati City, Metro Manila",
        city: "Manila",
        lat: 14.5634505,
        lng: 121.021978,
        isClean: true,
      },
    ],
  },
];
